{
  "name": "modulo-gestione-progetto",
  "version": "2.0.8-SNAPSHOT",
  "scripts": {
    "build": "npm run webapp:prod --",
    "build-watch": "concurrently 'npm run webapp:build:dev -- --watch'",
    "ci:frontend:build": "npm run webapp:build:$npm_package_config_default_environment",
    "ci:frontend:test": "npm run ci:frontend:build && npm test",
    "clean-coverage": "rimraf .nyc_output coverage",
    "clean-www": "rimraf target/classes/static/app/{src,target/}",
    "cleanup": "rimraf target/classes/static/",
    "cypress": "cypress open",
    "cypress:audits": "cypress open --config-file cypress-audits.json",
    "e2e": "npm run e2e:cypress:headed --",
    "e2e:cypress": "cypress run --browser chrome --record ${CYPRESS_ENABLE_RECORD:-false}",
    "e2e:cypress:audits": "cypress run --browser chrome --record ${CYPRESS_ENABLE_RECORD:-false} --config-file cypress-audits.json",
    "e2e:cypress:audits:headless": "npm run e2e:cypress -- --config-file cypress-audits.json",
    "pree2e:cypress:coverage": "npm run clean coverage && npm run ci:server:await",
    "e2e:cypress:coverage": "npm run e2e:cypress:headed",
    "poste2e:cypress:coverage": "nyc report",
    "e2e:cypress:headed": "npm run e2e:cypress -- --headed",
    "e2e:headless": "npm run e2e:cypress --",
    "jest": "jest --coverage --logHeapUsage --maxWorkers=2 --config jest.conf.js",
    "lint": "eslint . --ext .js,.ts",
    "lint:fix": "npm run lint -- --fix",
    "prepare": "husky install",
    "prettier:check": "prettier --check \"{,src/**/,webpack/}*.{md,json,yml,html,cjs,mjs,js,ts,tsx,css,scss}\"",
    "prettier:format": "prettier --write \"{,src/**/,webpack/}*.{md,json,yml,html,cjs,mjs,js,ts,tsx,css,scss}\"",
    "serve": "npm run start --",
    "sonar": "sonar-scanner",
    "start": "ng serve",
    "start-tls": "npm run webapp:dev-ssl",
    "pretest": "npm run lint",
    "test": "ng test --coverage --log-heap-usage -w=2",
    "test:watch": "npm run test -- --watch",
    "watch": "concurrently npm:start",
    "webapp:build": "npm run clean-www && npm run webapp:build:dev",
    "webapp:build:dev": "ng build --configuration development",
    "webapp:build:prod": "ng build --configuration production",
    "webapp:dev": "ng serve",
    "webapp:dev-ssl": "ng serve --ssl",
    "webapp:dev-verbose": "ng serve --verbose",
    "prewebapp:instrumenter": "npm run clean-www && npm run clean-coverage",
    "webapp:instrumenter": "ng build --configuration instrumenter",
    "webapp:prod": "npm run clean-www && npm run webapp:build:prod",
    "webapp:test": "npm run test --"
  },
  "private": true,
  "overrides": {
    "tslib": "2.4.1",
    "@fortawesome/angular-fontawesome": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    },
    "ngx-webstorage": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    },
    "@ng-bootstrap/ng-bootstrap": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common",
      "@angular/forms": "$@angular/forms",
      "@angular/localize": "$@angular/localize"
    },
    "@ng-select/ng-select": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common",
      "@angular/forms": "$@angular/forms"
    },
    "ngx-toastr": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    },
    "ngx-spinner": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    },
    "ngx-chips": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common",
      "@angular/forms": "$@angular/forms"
    }
  },
  "dependencies": {
    "@angular/animations": "20.3.30",
    "@angular/common": "20.3.30",
    "@angular/compiler": "20.3.30",
    "@angular/core": "20.3.30",
    "@angular/forms": "20.3.30",
    "@angular/localize": "20.3.30",
    "@angular/platform-browser": "20.3.30",
    "@angular/platform-browser-dynamic": "20.3.30",
    "@angular/router": "20.3.30",
    "@datorama/akita": "^8.0.1",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-svg-core": "1.2.36",
    "@fortawesome/free-brands-svg-icons": "^5.15.4",
    "@fortawesome/free-solid-svg-icons": "5.15.4",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ng-select/ng-select": "^15.1.3",
    "bootstrap": "^5.1.3",
    "browser-sync-client": "^3.0.4",
    "dayjs": "1.10.7",
    "ngx-chips": "^3.0.0",
    "ngx-spinner": "^18.0.0",
    "ngx-toastr": "^19.0.0",
    "rxjs": "^7.5.2",
    "tar": "^7.5.22",
    "tslib": "2.4.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular/build": "^20.3.17",
    "@angular/cli": "^20.3.17",
    "@angular/compiler-cli": "20.3.30",
    "@angular/service-worker": "20.3.30",
    "@cypress/code-coverage": "^4.0.3",
    "@types/jest": "^30.0.0",
    "@types/node": "~8.9.4",
    "@typescript-eslint/eslint-plugin": "^8.0.0",
    "@typescript-eslint/parser": "^8.0.0",
    "ajv": "^8.0.0",
    "ajv-keywords": "^5.0.0",
    "babel-plugin-istanbul": "6.1.1",
    "browser-sync": "^1.9.2",
    "concurrently": "6.3.0",
    "cypress": "^15.11.0",
    "cypress-audit": "^1.0.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "8.3.0",
    "eslint-plugin-cypress": "2.12.1",
    "husky": "7.0.2",
    "jest": "^30.0.0",
    "jest-date-mock": "1.0.8",
    "jest-junit": "^17.0.0",
    "jest-preset-angular": "^16.1.1",
    "jest-sonar-reporter": "2.0.0",
    "lighthouse": "^12.8.2",
    "lint-staged": "11.2.3",
    "ngx-webstorage": "^22.0.0",
    "nyc": "^18.0.0",
    "prettier": "2.4.1",
    "prettier-plugin-packagejson": "2.2.13",
    "rimraf": "3.0.2",
    "typescript": "^5.9.0",
    "wait-on": "^9.0.4"
  },
  "engines": {
    "node": ">=20.19.0"
  },
  "cacheDirectories": [
    "node_modules"
  ],
  "jestSonar": {
    "reportPath": "target/test-results/jest",
    "reportFile": "TESTS-results-sonar.xml"
  }
}
